import { normalize } from 'normalizr';
import fieldSettings from './fields/constants';
import { showModal } from './ui/actions';
import * as schema from './schema';
import { ROUTES } from 'Settings/route-strings';

export const handleError = (dispatch, error, type, optionalArgs = {}) => {
  if (error.errorCode === 68) {
    dispatch(showModal('read-only-mode'));
  }
  if (error.errorCode === 92) {
    const { school, user, username, licenses } = error.errorVals;
    const nSchool = normalize(school, schema.school);
    const nUser = normalize({ ...user, username }, schema.user);
    dispatch({
      type: 'FAILED_LOGIN_IN_EXPIRED_SCHOOL',
      failedLoginErrorVars: {
        redirectRoute: ROUTES.SETTINGS_SUBSCRIPTION_ACTIVATION,
        school: nSchool.entities.schools[nSchool.result],
        user: nUser.entities.users[nUser.result],
        license: licenses[0],
        password: optionalArgs.fieldsByName.password.value,
      },
    });
  }
  return dispatch({
    type,
    error,
    ...optionalArgs,
  });
};

const receiveAPIObjects = (results, type, objectSchema, optionalArgs) => {
  const normalizedResponse = normalize(results, objectSchema);
  return {
    type,
    response: normalizedResponse,
    ...optionalArgs,
  };
};

export const receiveClasses = (json, type, optionalArgs = {}) => {
  return receiveAPIObjects(
    json.results,
    type,
    schema.arrayOfClasses,
    optionalArgs
  );
};

export const receiveSchool = (json, type, optionalArgs = {}) => {
  return receiveAPIObjects(json.results, type, schema.school, optionalArgs);
};
export const receiveSchools = (json, type, optionalArgs = {}) => {
  return receiveAPIObjects(
    json.results,
    type,
    schema.arrayOfSchools,
    optionalArgs
  );
};

export const receiveUsers = (json, type, optionalArgs = {}) => {
  return receiveAPIObjects(
    json.results,
    type,
    schema.arrayOfUsers,
    optionalArgs
  );
};

export const checkTemporaryTokenValidity = (
  token,
  actionSlug,
  apiEndpoint,
  dispatch
) => {
  dispatch({
    type: `CHECK_${actionSlug}_TOKEN_REQUEST`,
    token,
  });

  return apiEndpoint(token).then(
    response => {
      if (response.errorMsg) {
        handleError(dispatch, response, `CHECK_${actionSlug}_TOKEN_FAILURE`);
      } else {
        dispatch({
          type: `CHECK_${actionSlug}_TOKEN_SUCCESS`,
          response,
        });
      }
    },
    error => handleError(dispatch, error, `CHECK_${actionSlug}_TOKEN_FAILURE`)
  );
};

export const getInitialFields = (formName, formId, initialSettings = {}) => {
  const fieldDefaults = fieldSettings[formName];
  const fields = {};
  Object.keys(fieldDefaults).forEach(key => {
    const fieldValues = initialSettings[key] || {};
    const field = fieldDefaults[key];
    const value = field.type === 'checkbox' ? field.value : '';
    const originalValue = fieldValues.value;
    const isValid =
      field.type === 'checkbox'
        ? !field.requiredTrue
        : typeof fieldValues.value !== 'undefined' || !field.required;
    fields[`${formId}__${key}`] = {
      ...field,
      fieldName: key,
      formId,
      showError: false,
      value,
      originalValue,
      isValid,
      ...fieldValues,
    };
  });
  return fields;
};

const wait = ms => new Promise(r => setTimeout(r, ms));

export const retryOperation = (operation, delay, times) =>
  new Promise((resolve, reject) => {
    return operation()
      .then(response => {
        resolve(response);
      })
      .catch(reason => {
        if (times - 1 > 0) {
          return wait(delay)
            .then(retryOperation.bind(null, operation, delay, times - 1))
            .then(resolve)
            .catch(reject);
        }
        return reject(reason);
      });
  });
